var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ribbon-indicator noPrint",class:{
    'admin-ribbon': _vm.user && (_vm.user.isAdmin || _vm.user.isManagingAdmin),
    'provider-ribbon': _vm.user && _vm.user.isProvider,
    'patient-ribbon': _vm.user && _vm.user.isPatient,
  }},[_vm._v(" "+_vm._s(_vm.user ? "Welcome" : "")+" "),_c('span',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.user && _vm.user.last)+", "+_vm._s(_vm.user && _vm.user.first))])])
}
var staticRenderFns = []

export { render, staticRenderFns }